/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Aui 라이브러리를 정의한다.
 *
 * @file /src/Aui.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 6. 14.
 */
import './Aui.css';
import { VERSION } from '@base/Aui';
import { Components } from '@base/Components';
import { Viewport } from '@base/Viewport';
import * as Button from '@namespaces/components/Button';
import { Panel } from '@namespaces/components/Panel';
import { Window } from '@namespaces/components/Window';
import { Form } from '@namespaces/components/Form';
import { Grid } from '@namespaces/components/Grid';
import { List } from '@namespaces/components/List';
import { Desktop } from '@namespaces/components/Desktop';
import { Loading } from '@namespaces/components/Loading';
import { Menu } from '@namespaces/components/Menu';
import { Message } from '@namespaces/components/Message';
import { Navigation } from '@namespaces/components/Navigation';
import { Pagination } from '@namespaces/components/Pagination';
import { Taskbar } from '@namespaces/components/Taskbar';
import { Toolbar } from '@namespaces/components/Toolbar';
import { Tab } from '@namespaces/components/Tab';
import { Text } from '@namespaces/components/Text';
import { Viewer } from '@namespaces/components/Viewer';
import { Store } from '@namespaces/models/Store';
import { Utils } from '@namespaces/Utils';
import { AnimationFrames } from '@utils/AnimationFrames';
import { Scroller } from '@utils/Scroller';

import type { Table } from '@namespaces/models/Table';
import type { Record } from '@namespaces/models/Store';
import type { Field } from '@namespaces/components/Form';

const Aui = {
    VERSION,
    Components,
    Viewport,
    ...Button,
    Panel,
    Window,
    Form,
    Grid,
    List,
    Desktop,
    Loading,
    Menu,
    Message,
    Navigation,
    Pagination,
    Taskbar,
    Toolbar,
    Tab,
    Text,
    Viewer,
    Store,
    Utils,
    debug: () => {
        AnimationFrames.debug();
        Scroller.debug();
    },
};

export default Aui as typeof Aui & Table & Record & Field;
